<template>
<div>
    <div
        style="display: flex; gap: 15px; margin-bottom: -10px"
    >
        <div
            style="flex-grow: 0px; width: 90px; height: 90px; position: relative; border: 1px solid rgba(0,0,0,0.3);"
        >
            <div
                style="height: 100%; line-height: 90px; text-align: center; overflow: hidden;"
            >
                <span
                    :style="text_style_without_padding"
                >
                    Aa
                </span>
            </div>
        </div>

        <div
            style="flex-grow: 1; margin-bottom: 15px"
        >
            <v-textarea
                :label="label"
                v-model="text_value"
                v-on:input="onChangeText"
                :hint="hint"
                persistent-hint
                :style="style_text_field"
                rows="1"
                auto-grow
            />
            
            <m-icon-btn
              icon="mdi-format-font-size-increase"
              v-on:click="onStyleOp('increase-font-size')"
              text="Increase text size"
            />
             
            <m-icon-btn
              icon="mdi-format-font-size-decrease"
              v-on:click="onStyleOp('decrease-font-size')"
              text="Decrease text size"
            />
              
            <m-icon-btn
              icon="mdi-format-size"
              v-on:click="onClickSetFontSize"
              text="Set exact text size..."
            />
             
            <m-icon-btn
              icon="mdi-format-bold"
              text="Bold"
              v-on:click="onStyleOp('toggle-bold')"
            />
             
            <m-icon-btn
              icon="mdi-format-italic"
              text="Italic"
              v-on:click="onStyleOp('toggle-italic')"
            />
              
            <m-icon-btn
              icon="mdi-format-underline"
              text="Underline"  
              v-on:click="onStyleOp('toggle-underline')"
            />
              
            <m-icon-btn
              icon="mdi-format-font"
              text="Change font..."
              v-on:click="onClickSetFontFamily"
            />
              
            <m-icon-btn
              icon="mdi-palette"
              text="Change color..."
              v-on:click="onClickSetFontColor"
            />
              
            <m-icon-btn
              icon="mdi-keyboard-space"
              text="Change spacing (padding)..."
              v-on:click="onClickSpace"
            />
            
            <m-icon-btn
              :icon="toggle_show_icon"
              :text="toggle_show_text"
              v-on:click="onStyleOp('toggle-show')"
            />
              
            <m-icon-btn
              icon="mdi-restore"
              text="Return to default text or formatting..."
              v-on:click="onClickResetStyle"
            />
              
            
        </div>

        <m-edit-css-property-dialog
            ref="edit-css-property-dialog"
            v-on:modify="onModify"
        />

        
    </div>


</div>
</template>

<script>
const _ = require('lodash');
export default {
    props: {

        label: {
            type: String,
            default: function() { return 'Label'; }
        },

        value: {
            type: Object,
            default: function() { return {'text': null, 'style': 'font-size: 14px'}; }
        },

        hint: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            original_value: null,
            css_property_dialog_label: null,
            css_property_dialog_property_name: null,
        }
    },

    mounted() {
        this.original_value = _.cloneDeep(this.value);
    },

    methods: {
        onChangeText()
        {
            // This is now handled by the computed property setter
        },

        onStyleOp(op, ex_params)
        {
            if (!this.value) {
                return;
            }

            ex_params = ex_params ?? {};

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/css/inline/modify',

                'params' : {
                        'inline_style': this.value.style || '',
                        'op': op,
                        ...ex_params,
                    },

                'on_success': (data) => {
                        this.$emit('input', {
                            ... this.value,
                            'style': data.inline_style
                        });
                    },

                'on_error': 'Unable to adjust style',
            });
        },

        onClickSetFontSize()
        {
            this.css_property_dialog_label = 'Font Size';
            this.css_property_dialog_property_name = 'font-size';

            this.onClickSetCSSProperty();
        },

        onClickSpace()
        {
            this.css_property_dialog_label = 'Spacing (Padding)';
            this.css_property_dialog_property_name = 'padding';

            

            this.onClickSetCSSProperty( 
                {
                    "name": "padding",
                    "value": {
                        "type": "directional",
                        "raw_value": "0px 0px 0px 0px",
                        "red": null,
                        "green": null,
                        "blue": null,
                        "alpha": null,
                        "magnitude": null,
                        "unit": null,
                        "left": {
                        "magnitude": 0,
                        "unit": "px"
                        },
                        "right": {
                        "magnitude": 0,
                        "unit": "px"
                        },
                        "top": {
                        "magnitude": 0,
                        "unit": "px"
                        },
                        "bottom": {
                        "magnitude": 0,
                        "unit": "px"
                        },
                        "values": []
                    },
                    "default_value": {
                        "type": "directional",
                        "raw_value": "0px 0px 0px 0px",
                        "red": null,
                        "green": null,
                        "blue": null,
                        "alpha": null,
                        "magnitude": null,
                        "unit": null,
                        "left": {
                        "magnitude": 0,
                        "unit": "px"
                        },
                        "right": {
                        "magnitude": 0,
                        "unit": "px"
                        },
                        "top": {
                        "magnitude": 0,
                        "unit": "px"
                        },
                        "bottom": {
                        "magnitude": 0,
                        "unit": "px"
                        },
                        "values": []
                    }
                    }
            );
        },

        onClickSetFontColor()
        {
            this.css_property_dialog_label = 'Text Color';
            this.css_property_dialog_property_name = 'color';

            this.onClickSetCSSProperty();
        },

        onClickSetFontFamily()
        {
            this.css_property_dialog_label = 'Font Family';
            this.css_property_dialog_property_name = 'font-family';

            this.onClickSetCSSProperty();
        },

        onClickSetCSSProperty(default_value)
        {
            if (!this.value) {
                return;
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/css/inline/parse',

                'params' : {
                        'inline_style': this.value.style || '',
                        'default_inline_style': this.value.default_style || '',
                    },

                'on_success': (data) => {

                        let property = data.properties
                            .find(el => el.name == this.css_property_dialog_property_name);

                        // If property not found in response, use the provided default_value
                        let value = property ?? default_value;

                        this.$refs['edit-css-property-dialog'].showDialog({
                            'label': this.css_property_dialog_label,
                            'property_name': this.css_property_dialog_property_name,
                            'value': value,
                            'preview_text': this.value.text || 'Sample Text',
                        });
                    },

                'on_error': 'Unable to get property value',
            });
        },

        onModify(operation)
        {
            this.onStyleOp(operation.op, {'property_name': operation.property_name, 'value': operation.value});
        },
        
        onClickResetStyle()
        {
            this.$rc.pick({
                'title': 'Reset',
                'content_before': null,
                'content_after': '<b>Warning:  </b>This can not be undone.',
            
                'choices': [
                    {'text': 'Formatting Only', 'value': 'format-only'},
                    {'text': 'Text Only', 'value': 'text-only'},
                    {'text': 'Text and Formatting', 'value': 'text-and-formatting'},
                ],
            
                'multiple': false,
                'type': 'select',
                'select_label': 'What would you like to reset?',
                'initial_value': null,
                'unset_label': null,
                'ok_text': 'Reset',
            
                'on_ok': (value) => {
                    this.doReset(value);
                },
            
                'on_cancel': () => {}
            
            });
        },

        doReset(type)
        {
            if (!this.value) {
                return;
            }

            let new_value = _.cloneDeep(this.value);

            if ( type == 'format-only' )
            {
                new_value.style = this.original_value?.style || this.value.default_style || '';
            }

            if ( type == 'text-only' )
            {
                new_value.text = this.original_value?.text || this.value.default_text || '';
            }

            if ( type == 'text-and-formatting' )
            {
                new_value.style = this.original_value?.style || this.value.default_style || '';
                new_value.text = this.original_value?.text || this.value.default_text || '';
            }

            this.$emit('input', new_value);
        },
    },

    computed: {
        text_value: {
            get() {
                return this.value && this.value.text ? this.value.text : '';
            },
            set(newValue) {
                if (this.value) {
                    this.$emit('input', {
                        ...this.value,
                        text: newValue
                    });
                }
            }
        },

        style_text_field() {
            if ( this.hint == null )
                return null;

            return 'margin-bottom: 15px;'
        },

        toggle_show_icon()
        {
            let style = '';

            if ( this.value != null && this.value.style != null )
                style = this.value.style;

            if ( style.toLowerCase().includes('display: none') )
                return 'mdi-eye';

            return 'mdi-eye-off';
        },

        toggle_show_text()
        {
            let style = '';

            if ( this.value != null && this.value.style != null )
                style = this.value.style;

            if ( style.toLowerCase().includes('display: none') )
                return 'Show';

            return 'Hide';
        },

        text_style_without_padding()
        {
            if (!this.value || !this.value.style) {
                return '';
            }

            let ret = this.value.style;
            ret = ret.toLowerCase();

            ret = ret.replace('padding:','padding-disabled:');
            return ret;
        },
    },
}
</script>

<style lang="scss" scoped>
.checker
{
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
    
    background-image: url('https://files.redchirp.com/dcf69ef7-2e39-4bcd-b0ca-cd4be32eeff2.webp'); 
    background-size: cover; 
    background-position: center;
    background-repeat: no-repeat;

    z-index: 1;
}

.swatch
{
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    z-index: 2;
}

.icon-button
{
    margin-top: -15px;
    margin-bottom: 15px;
}

</style>